import type { QueryKey } from "@tanstack/react-query"

import { EVENT_DETAILS_QUERY_KEY } from "@/modules/events/constants/api"

type GetEventDetailsQueryKeyParams = {
  slug: string
}

export function getEventDetailsQueryKey({ slug }: GetEventDetailsQueryKeyParams): QueryKey {
  return [EVENT_DETAILS_QUERY_KEY, slug]
}
